import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { updateProfile } from "./profiles"; // Action for sending credit card to financial profile

export var updateFinancialProfile = function updateFinancialProfile(profile) {
  return updateProfile({
    actionName: 'updateFinancialProfile',
    data: profile,
    profileType: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
    showMessages: true,
    meta: {
      updating: 'accounts',
      card: profile
    }
  });
};